module.exports = __webpack_public_path__ + "static/media/22ESCWA10.0a72c9d0.jpg";